// src/pages/EditProfile.js
import React, { useEffect, useState } from "react";
import { auth, db, storeage } from "../Firebase/Config";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

function EditProfile() {
  const [profile, setProfile] = useState({
    displayName: "",
    phone: "",
    photoURL: "",
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const user = auth.currentUser;

  // Fetch profile on mount
  useEffect(() => {
    const fetchProfile = async () => {
      if (!user) return setLoading(false);
      try {
        const profileDoc = await getDoc(doc(db, "users", user.uid, "profile"));
        if (profileDoc.exists()) {
          setProfile(profileDoc.data());
        }
      } catch (err) {
        alert("Could not load profile.");
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, [user]);

  // Handle form input changes
  const handleChange = (e) =>
    setProfile({ ...profile, [e.target.name]: e.target.value });

  // Handle photo upload
  const handlePhoto = async (e) => {
    if (!user) return;
    const file = e.target.files[0];
    if (!file) return;
    const photoRef = ref(storeage, `profile_pics/${user.uid}`);
    await uploadBytes(photoRef, file);
    const url = await getDownloadURL(photoRef);
    setProfile((p) => ({ ...p, photoURL: url }));
  };

  // Save profile to Firestore
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) return;
    setSaving(true);
    try {
      await setDoc(doc(db, "users", user.uid, "profile"), profile);
      alert("Profile updated!");
    } catch (err) {
      alert("Could not save profile: " + err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div>Loading profile...</div>;

  return (
    <div
      style={{
        maxWidth: 420,
        margin: "2rem auto",
        padding: 24,
        background: "#fff",
        borderRadius: 8,
        boxShadow: "0 2px 14px #eaeaea",
      }}
    >
      <h2>Edit Profile</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 12 }}>
          <label>Name</label>
          <input
            name="displayName"
            value={profile.displayName}
            onChange={handleChange}
            placeholder="Full Name"
            required
            style={inputStyle}
          />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>Phone</label>
          <input
            name="phone"
            value={profile.phone}
            onChange={handleChange}
            placeholder="Phone Number"
            style={inputStyle}
          />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>Profile Photo</label>
          <input type="file" accept="image/*" onChange={handlePhoto} />
          {profile.photoURL && (
            <div style={{ marginTop: 8 }}>
              <img
                src={profile.photoURL}
                alt="Profile"
                width={80}
                style={{ borderRadius: "50%" }}
              />
            </div>
          )}
        </div>
        <button type="submit" disabled={saving} style={btnStyle}>
          {saving ? "Saving..." : "Save Profile"}
        </button>
      </form>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: 8,
  borderRadius: 4,
  border: "1px solid #ddd",
  marginTop: 4,
};
const btnStyle = {
  marginTop: 12,
  background: "#4cf3d2",
  padding: "0.7rem 2rem",
  borderRadius: 5,
  border: "none",
  fontWeight: "bold",
  cursor: "pointer",
};

export default EditProfile;
